export const FILTER_BUTTONS = [
  { name: 'all' },
  { name: 'health' },
  { name: 'retail' },
  { name: 'bank' },
  { name: 'transport' },
];
